import { enIfoodOrderStatus } from '../interfaces/IIfoodOrder';

export const estagios = {
  0: {
    significado: 'Pedido em aguardo',
    texto: 'Aguardando',
    color: '#329BFC',
  },
  1: {
    significado: 'Pedido aceito',
    texto: 'Aceito',
    color: '#FF8946',
  },
  2: {
    significado: 'Pedido negado',
    texto: 'Cancelado',
    color: '#F64444',
  },
  3: {
    significado: 'Pedido em preparação',
    texto: 'Preparando',
    color: '#FF8946',
  },
  4: {
    significado: 'Pedido pronto',
    texto: 'Pronto para Entraga',
    color: '#B24AD9',
  },
  5: {
    significado: 'Pedido em rota de entrega',
    texto: 'Rota de entrega',
    color: '#B24AD9',
  },
  6: {
    significado: 'Pedido entregue',
    texto: 'Entregue',
    color: '#35BA83',
  },
  7: {
    significado: 'Pedido faturado',
    texto: 'Finalizado',
    color: '#35BA83',
  },
  8: {
    significado: 'Pedido separado',
    texto: 'Separado',
    color: '#B24AD9',
  },
  9: {
    significado: 'Pedido cancelado pela loja',
    texto: 'Cancelado',
    color: '#F64444',
  },
  10: {
    significado: 'Pedido cancelado pelo cliente',
    texto: 'Cancelado',
    color: '#F64444',
  },
  11: {
    significado: 'Pedido pronto para retirada na loja',
    texto: 'Pronto para retirada',
    color: '#B24AD9',
  },
  12: {
    significado: 'Pedido em separação',
    texto: 'Em separação',
    color: '#FF8946',
  },
};

export const foundEstagio = (
  estagio: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12,
): { significado: string; texto: string; color: string } => {
  return estagios[estagio];
};

// opção de cores: #ff006e / #ffbe0b

export const estagiosIfood = {
  PLACED: {
    significado: 'Pedido em aguardo',
    texto: 'Aguardando',
    color: '#329BFC',
  },
  CONFIRMED: {
    significado: 'Pedido aceito',
    texto: 'Aceito',
    color: '#FF8946',
  },
  CANCELLED: {
    significado: 'Pedido negado',
    texto: 'Cancelado',
    color: '#F64444',
  },
  PREPARATION_STARTED: {
    significado: 'Pedido em preparação',
    texto: 'Preparando',
    color: '#FF8946',
  },
  DISPATCHED: {
    significado: 'Pedido em rota de entrega',
    texto: 'Rota de entrega',
    color: '#B24AD9',
  },
  CONCLUDED: {
    significado: 'Pedido faturado',
    texto: 'Finalizado',
    color: '#35BA83',
  },
  READ_TO_PICKUP: {
    significado: 'Pedido pronto para retirada na loja',
    texto: 'Pronto para retirada',
    color: '#B24AD9',
  },
};

export const foundEstagioIfood = (
  estagio: enIfoodOrderStatus,
): { significado: string; texto: string; color: string } => {
  return estagiosIfood[estagio];
};
